<template>
  <div class="row">
    <div
      v-for="game in games.filter(
        g =>
          (idteam1 === g.player1_id && idteam2 === g.player2_id) ||
          (idteam1 === g.player2_id && idteam2 === g.player1_id)
      )"
      :key="game.game_id"
      class="game-score col-6 p-0"
    >
      <div
        v-if="
          idteam1 === game.player1_id && idteam2 === game.player2_id
        "
        class="py-1"
      >
        <span v-if="game.score_side1 > game.score_side2" class="score-block">
          <span :class="dataSport.textClass">{{ game.score_side1 }}</span>
          <span class="separator text-white">-</span>
          <span class="text-white">{{ game.score_side2 }}</span>
        </span>
        <span
          v-else-if="game.score_side1 < game.score_side2"
          class="score-block"
        >
          <span class="text-white">{{ game.score_side1 }}</span>
          <span class="separator text-white">-</span>
          <span :class="dataSport.textClass">{{ game.score_side2 }}</span>
        </span>
        <span
          v-else-if="
            game.score_side1 === game.score_side2 && game.state === 'finished'
          "
          class="score-block"
        >
          <span class="text-white">{{ game.score_side1 }}</span>
          <span class="separator text-white">-</span>
          <span class="text-white">{{ game.score_side2 }}</span>
        </span>
        <span v-else>
          <b class="separator text-white-50">-</b>
        </span>
      </div>
      <div
        v-else-if="
          idteam1 === game.player2_id && idteam2 === game.player1_id
        "
        class="py-1"
      >
        <span v-if="game.score_side2 > game.score_side1" class="score-block">
          <span :class="dataSport.textClass">{{ game.score_side2 }}</span>
          <span class="separator text-white">-</span>
          <span class="text-white">{{ game.score_side1 }}</span>
        </span>
        <span
          v-else-if="game.score_side2 < game.score_side1"
          class="score-block"
        >
          <span class="text-white">{{ game.score_side2 }}</span>
          <span class="separator text-white">-</span>
          <span :class="dataSport.textClass">{{ game.score_side1 }}</span>
        </span>
        <span
          v-else-if="
            game.score_side2 === game.score_side1 && game.state === 'finished'
          "
          class="score-block"
        >
          <span class="text-white">{{ game.score_side1 }}</span>
          <span class="separator text-white">-</span>
          <span class="text-white">{{ game.score_side2 }}</span>
        </span>
        <span v-else>
          <b class="separator text-white-50">-</b>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GridGamesScore1x1",
  props: ["games", "idteam1", "idteam2", "dataSport"]
};
</script>

<style scoped>
.separator {
  font-size: 17px;
  font-weight: 400;
  padding: 0 2px;
}
.game-score {
  font-size: 14px;
  line-height: 17px;
}
.score-block::after {
  content: " ";
  display: block;
}
</style>
